export default function isNumberInRange(number, range) {
    // Assuming range is an array with two elements [min, max]
    return number >= range[0] && number <= range[1];
}